module.exports = __webpack_public_path__ + "img/germinations_door.f7d0f8d0.png";